import React, {createContext, useContext} from "react";
import {useAuth as useFirebaseAuth, AuthContextType} from "./hooks/useAuth";

// Create context with the Firebase auth hook
const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{children: React.ReactNode}> = ({
  children,
}) => {
  const auth = useFirebaseAuth();

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};

export const useAuth = (): AuthContextType => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};

// Re-export types for backward compatibility
export type {UserRole} from "./services/firebase/auth";
